/**
 *｜--------------------------------------------------------------------------
 *｜Author     : 1045998323@qq.com
 *｜Class      : toast
 *｜CreateTime ：2024/9/25 14:21
 *｜Notes      : 类说明
 *｜--------------------------------------------------------------------------
 */
import Noty from "noty";
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/relax.css";
import { APP_ENV } from "@/APP_ENV";

export function toast(options) {
  return new Noty({
    theme: "relax",
    type: "error",
    layout: "topRight",
    closeWith: ["click", "button"],
    timeout: APP_ENV.REACT_APP_NOTY_TIMEOUT || 3000,
    ...options
  }).show();
}

toast.success = (msg, callbacks = {}) => {
  return toast({
    type: "success",
    text: msg,
    callbacks
  });
};

toast.error = (msg, callbacks = {}) => {
  return toast({
    type: "error",
    text: msg || "Unknown Error",
    callbacks
  });
};

toast.info = (msg, callbacks = {}) => {
  return toast({
    type: "info",
    text: msg,
    callbacks
  });
};

toast.warning = (msg, callbacks = {}) => {
  return toast({
    type: "warning",
    text: msg,
    callbacks
  });
};

toast.alert = (msg, callbacks = {}) => {
  // return toast({
  //   type: "alert",
  //   text: msg,
  //   callbacks
  // });
  const n = toast({
    type: "alert",
    layout: "center",
    timeout: false,
    text: msg,
    closeWith: [],
    callbacks,
    animation: {
      open: "noty_alert_effects_open",
      close: "noty_alert_effects_close"
    },
    buttons: [
      Noty.button("OK", "noty_button", () => {
        n.close();
      })
    ]
  });
  return n;
};

toast.confirm = (msg, callbacks = {}) => {
  const n = toast({
    type: "alert",
    layout: "center",
    timeout: false,
    text: msg,
    closeWith: [],
    callbacks,
    animation: {
      open: "noty_alert_effects_open",
      close: "noty_alert_effects_close"
    },
    buttons: [
      Noty.button("confirm", "noty_button success", () => {
        callbacks.onConfirm?.();
        n.close();
      }),
      Noty.button("OK", "noty_button", () => {
        callbacks.onCancel?.();
        n.close();
      })
    ]
  });
  return n;
};
